import { Reveal } from "@/components/Reveal";
import { Sparkles, Music, Coffee } from "lucide-react";
import { SCHEDULE } from "@/data";

const ICONS = { Sparkles, Music, Coffee };

export const Schedule = () => (
  <section id="program" className="py-20 md:py-28">
    <div className="mx-auto max-w-4xl px-6">
      <Reveal>
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.22em] text-[var(--accent)]">
          {SCHEDULE.eyebrow}
        </p>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="font-display text-3xl md:text-4xl font-bold text-[var(--ink)]">
          {SCHEDULE.title}
        </h2>
      </Reveal>

      <div className="mt-14 space-y-0">
        {SCHEDULE.events.map((ev, i) => (
          <Reveal key={ev.time} delay={0.06 * i}>
            <div className="relative flex items-start gap-6 pb-10 pl-2">
              <div className="relative flex flex-col items-center">
                <span className="z-10 mt-1.5 h-3.5 w-3.5 rounded-full bg-[var(--forest)] ring-4 ring-[var(--cream)]" />
                {i < SCHEDULE.events.length - 1 && (
                  <span className="absolute top-3 h-full w-px bg-[var(--forest)]/20" />
                )}
              </div>
              <div className="flex flex-1 flex-col gap-1 sm:flex-row sm:gap-8">
                <span className="font-display text-lg font-bold text-[var(--forest)] sm:w-20">
                  {ev.time}
                </span>
                <span className="text-base md:text-lg text-[var(--ink)]/85">
                  {ev.description}
                </span>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div className="mt-6 rounded-3xl bg-[var(--highlight)]/45 p-8 md:p-10">
          <div className="mb-7 flex items-center gap-2">
            <Sparkles className="h-5 w-5 text-[var(--forest)]" />
            <h3 className="font-display text-xl font-semibold text-[var(--forest-dark)]">
              {SCHEDULE.extraTitle}
            </h3>
          </div>
          <div className="grid gap-8 sm:grid-cols-3">
            {SCHEDULE.extras.map((x) => {
              const Icon = ICONS[x.icon];
              return (
                <div key={x.text} className="flex flex-col gap-3">
                  <Icon className="h-6 w-6 text-[var(--forest)]" />
                  <p className="text-sm leading-relaxed text-[var(--ink)]/80">
                    {x.text}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
